import {
  Icon,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Popover,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Typography,
  IconButton
} from "@material-ui/core";
import cx from "classnames";
import EnhancedTableHead from "components/EnhancedTableHead/EnhancedTableHead.jsx";
import { SearchDataSet } from "helpers/Search";
import {
  GetUserId,
  GetUserToken,
  Logout,
  GetUserKey
} from "helpers/UserHelper";
//Q&Ms
import { userManagement } from "queries/UserManagement";
import {
  ActivateUser,
  DeactivateUser,
  DeclineUser,
  DeleteUser
} from "queries/user_management/ChangeUserStatus";
import React, { Component } from "react";
import { compose, graphql, Query } from "react-apollo";
import { Redirect } from "react-router";
import store from "store";
import { UserStatus } from "../../enums/user_management.js";
import { alertWarning, showSnack } from "../../reducers/NotificationReducer";
import BaseTablePageContent from "./components/BaseTablePageContent.jsx";
import InviteUsersModal from "./components/InviteUsersModal";

const columnData = [
  {
    id: "edit",
    numeric: false,
    disablePadding: true,
    label: "",
    noSort: true,
    width: "30px"
  },
  {
    id: "su_ID",
    numeric: false,
    disablePadding: true,
    label: "Status",
    noSort: true
  },
  { id: "su_name", numeric: false, disablePadding: true, label: "Name" },
  { id: "su_email", numeric: false, disablePadding: true, label: "Email" },
  { id: "type", numeric: false, disablePadding: true, label: "Type" }
];

const userLimits = {
  broker: 10,
  assistant: 10
};

class UserManagement extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    order: "desc",
    orderBy: "",
    searchTerm: "",
    loadingSearch: false,
    refresh: false,
    data: [],
    searchData: [],
    openMenus: [],
    anchorTop: 0,
    anchorLeft: 0,
    popoverOpen: false,
    statuses: [UserStatus.Inactive, UserStatus.Requested, UserStatus.Active],
    activeCount: {
      broker: 0,
      assistant: 0
    },
    inviteDialogOpen: false
  };

  handleSearch = event => {
    this.setState({ searchTerm: event.target.value });

    let values = event.target.value.split(" ");
    var brokers = this.state.data;
    var inc = ["su_name", "su_surname", "su_email"];

    var filteredData = SearchDataSet(brokers, values, inc);
    this.setState({ searchData: filteredData });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  }

  handleClaim = b => {};

  handleRemove = () => {};

  handleClick = (event, id) => {
    this.setState({ anchorTop: event.clientY, anchorLeft: event.clientX });

    var openMenus = this.state.openMenus.slice();
    openMenus.filter(x => x.id === id)[0].open = true;
    this.setState({ openMenus: openMenus, popoverOpen: true });
  };

  handleClose = id => {
    var openMenus = this.state.openMenus.slice();
    openMenus.filter(x => x.id === id)[0].open = false;
    this.setState({ openMenus: openMenus, popoverOpen: false });
  };

  toggleFilterItem = (refetch, item) => {
    if (item !== "all") {
      let statuses = [...this.state.statuses];
      if (statuses.includes(item)) {
        statuses = statuses.filter(s => s !== item);
      } else {
        statuses.push(item);
      }

      this.setState({ statuses: statuses });
      refetch();
      this.setState({ refresh: true });
    }
  };

  checkAvailableSlots(user) {
    let activeCount = 0;
    let limit = userLimits[user.type];

    this.state.data
      .filter(u => u.type === user.type)
      .map(u => {
        if (u.status === UserStatus.Active) activeCount++;
        return u;
      });

    if (activeCount === limit) {
      store.dispatch(
        alertWarning({
          open: true,
          title: "Not enough open slots",
          message: (
            <div style={{ width: "80%", margin: "auto", textAlign: "center" }}>
              <Typography variant="body1">
                Please ensure that there are sufficient amount of{" "}
                <strong>{user.type}</strong> slots available.
              </Typography>
            </div>
          )
        })
      );
      return false;
    }
    return true;
  }

  activateUser = (refetch, user) => {
    if (!this.checkAvailableSlots(user)) return;
    const input = {
      userId: user.su_ID,
      userType: user.type,
      token: GetUserToken()
    };

    this.props
      .ActivateUser({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.setState({ refresh: true });
        store.dispatch(
          showSnack({
            message: "User Activated",
            color: "success"
          })
        );
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  deactivateUser = (refetch, user) => {
    const input = {
      userId: user.su_ID,
      userType: user.type,
      token: GetUserToken()
    };

    this.props
      .DeactivateUser({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.setState({ refresh: true });
        store.dispatch(
          showSnack({
            message: "User De-activated",
            color: "danger"
          })
        );
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  declineUser = (refetch, user) => {
    const input = {
      userId: user.su_ID,
      userType: user.type,
      token: GetUserToken()
    };

    this.props
      .DeclineUser({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.setState({ refresh: true });
        store.dispatch(
          showSnack({
            message: "User Declined",
            color: "danger"
          })
        );
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  deleteUser = (refetch, user) => {
    const input = {
      userId: user.su_ID,
      userType: user.type,
      token: GetUserToken()
    };

    this.props
      .DeleteUser({
        variables: {
          input
        }
      })
      .then(resp => {
        refetch();
        this.setState({ refresh: true });
        store.dispatch(
          showSnack({
            message: "User Deleted",
            color: "danger"
          })
        );
      })
      .catch(error => {
        console.log("err", error);
      });
  };

  openInviteDialog = () => {
    this.setState({ inviteDialogOpen: true });
  };

  closeInviteDialog = (refetch, willRefetch) => {
    this.setState({ inviteDialogOpen: false });

    if (willRefetch) {
      refetch();
    }
  };

  render() {
    return (
      <Query
        query={userManagement}
        variables={{
          brokerageId: GetUserId(),
          token: GetUserToken(),
          statuses: this.state.statuses
        }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <React.Fragment>
                <BaseTablePageContent
                  handleSearch={e => {
                    return;
                  }}
                  title="Brokerage Management"
                  toggleFilterItem={item =>
                    this.toggleFilterItem(refetch, item)
                  }
                  filters={this.state.statuses}
                >
                  <LinearProgress />
                </BaseTablePageContent>
              </React.Fragment>
            );

          if (
            error &&
            error.message &&
            error.message === "GraphQL error: invalid token"
          ) {
            Logout();
            return <Redirect to="/app/portal/login" />;
          }

          if (
            this.state.data.length !== data.UserManagement.length ||
            this.state.refresh
          ) {
            this.setState({ data: data.UserManagement, refresh: false });
          }

          let qData = [];
          if (
            this.state.searchData.length > 0 &&
            this.state.searchTerm !== ""
          ) {
            qData = this.state.searchData.slice();
          } else {
            qData = data.UserManagement.slice();
          }

          if (this.state.orderBy !== "") {
            qData.sort(this.getSorting(this.state.order, this.state.orderBy));
          }

          if (qData && this.state.openMenus.length !== qData.length) {
            let openMenus = [];

            qData.map(b => {
              openMenus.push({
                open: false,
                id: b.su_ID
              });
              return b;
            });

            this.setState({ openMenus: openMenus });
          }

          let activeCount = {};
          data.UserManagement.map(u => {
            if (u.status === UserStatus.Active) {
              if (!activeCount[u.type]) {
                activeCount[u.type] = 1;
              } else {
                activeCount[u.type] = activeCount[u.type] + 1;
              }
            }
            return u;
          });

          //console.log('activeCount', activeCount);

          return (
            <React.Fragment>
              <BaseTablePageContent
                handleSearch={this.handleSearch}
                title="Brokerage Users"
                toggleFilterItem={item => this.toggleFilterItem(refetch, item)}
                filters={this.state.statuses}
                typeDetails={{
                  activeCount: activeCount,
                  userLimits: userLimits
                }}
                openInviteDialog={this.openInviteDialog}
              >
                <Table>
                  <EnhancedTableHead
                    order={this.state.order}
                    orderBy={this.state.orderBy}
                    onRequestSort={this.handleRequestSort}
                    rowCount={
                      this.state.searchData.length < 1 &&
                      this.state.searchTerm !== ""
                        ? this.state.searchData.length
                        : qData.length
                    }
                    columnData={columnData}
                  />
                  <TableBody>
                    {this.state.searchData.length < 1 &&
                    this.state.searchTerm !== "" ? (
                      <TableRow>
                        <TableCell colSpan={5}>
                          <h3>No results found</h3>
                        </TableCell>
                      </TableRow>
                    ) : (
                      <React.Fragment>
                        {this.state.searchTerm === "" ? (
                          <TableRow>
                            <TableCell
                              style={{
                                padding: "0px"
                              }}
                            />
                            <TableCell />
                            <TableCell>
                              <Typography>{`${GetUserKey("name")} ${GetUserKey(
                                "surname"
                              )} (You)`}</Typography>
                            </TableCell>
                            <TableCell>{GetUserKey("userEmail")}</TableCell>
                            <TableCell>Brokerage Admin</TableCell>
                          </TableRow>
                        ) : null}

                        {qData
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage +
                              this.state.rowsPerPage
                          )
                          .map(user => {
                            var openMenu = this.state.openMenus.find(
                              m => m.id === user.su_ID
                            );

                            return (
                              <TableRow
                                key={user.su_ID}
                                onClick={e =>
                                  this.state.popoverOpen === false
                                    ? this.handleClick(e, user.su_ID)
                                    : null
                                }
                                className={cx(
                                  "sqDataTable",
                                  user.status === UserStatus.Inactive
                                    ? "disabledRow"
                                    : null
                                )}
                                style={
                                  openMenu && openMenu.open
                                    ? { backgroundColor: "#dedede" }
                                    : {}
                                }
                              >
                                <TableCell
                                  style={{
                                    padding: "0px",
                                    borderRight: "1px solid #e0e0e0",
                                    backgroundColor: "white"
                                  }}
                                >
                                  <IconButton
                                    onClick={e =>
                                      this.state.popoverOpen === false
                                        ? this.handleClick(e, user.su_ID)
                                        : null
                                    }
                                  >
                                    <Icon>more_vert</Icon>
                                  </IconButton>
                                </TableCell>
                                <TableCell>
                                  <div style={{ display: "flex" }}>
                                    {user.status === UserStatus.Active ? (
                                      <React.Fragment>
                                        <Icon style={{ color: "#25b125" }}>
                                          account_circle
                                        </Icon>
                                        <Typography
                                          variant="caption"
                                          style={{
                                            marginLeft: "8px",
                                            top: "4px",
                                            position: "relative"
                                          }}
                                        >
                                          Active
                                        </Typography>
                                      </React.Fragment>
                                    ) : null}
                                    {user.status === UserStatus.Inactive ? (
                                      <React.Fragment>
                                        <Icon style={{ color: "#da5858b8" }}>
                                          account_circle
                                        </Icon>
                                        <Typography
                                          variant="caption"
                                          style={{
                                            marginLeft: "8px",
                                            top: "4px",
                                            position: "relative"
                                          }}
                                        >
                                          Inactive
                                        </Typography>
                                      </React.Fragment>
                                    ) : null}
                                    {user.status === UserStatus.Requested ? (
                                      <React.Fragment>
                                        <Icon style={{ color: "#84848494" }}>
                                          help_outline
                                        </Icon>
                                        <Typography
                                          variant="caption"
                                          style={{
                                            marginLeft: "8px",
                                            top: "4px",
                                            position: "relative"
                                          }}
                                        >
                                          Requested
                                        </Typography>
                                      </React.Fragment>
                                    ) : null}
                                  </div>
                                </TableCell>
                                <TableCell>
                                  {user.su_name} {user.su_surname}
                                </TableCell>
                                <TableCell>{user.su_email}</TableCell>
                                <TableCell>{user.type}</TableCell>
                                <Popover
                                  open={
                                    this.state.openMenus.length > 0 &&
                                    this.state.openMenus.filter(
                                      m => m.id === user.su_ID
                                    ).length > 0
                                      ? this.state.openMenus.filter(
                                          m => m.id === user.su_ID
                                        )[0].open
                                      : false
                                  }
                                  anchorReference="anchorPosition"
                                  anchorPosition={{
                                    left: this.state.anchorLeft,
                                    top: this.state.anchorTop
                                  }}
                                  onClose={() => this.handleClose(user.su_ID)}
                                >
                                  <List component="nav">
                                    {user.status === UserStatus.Active ? (
                                      <ListItem
                                        button
                                        onClick={() => {
                                          this.handleClose(user.su_ID);
                                          this.deactivateUser(refetch, user);
                                        }}
                                      >
                                        <ListItemText primary="Deactivate" />
                                      </ListItem>
                                    ) : user.status === UserStatus.Requested ? (
                                      <React.Fragment>
                                        <ListItem
                                          button
                                          onClick={() => {
                                            this.handleClose(user.su_ID);
                                            this.activateUser(refetch, user);
                                          }}
                                        >
                                          <ListItemText primary="Activate" />
                                        </ListItem>
                                        <ListItem
                                          button
                                          onClick={() => {
                                            this.handleClose(user.su_ID);
                                            this.declineUser(refetch, user);
                                          }}
                                        >
                                          <ListItemText primary="Decline" />
                                        </ListItem>
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        <ListItem
                                          button
                                          onClick={() => {
                                            this.handleClose(user.su_ID);
                                            this.activateUser(refetch, user);
                                          }}
                                        >
                                          <ListItemText primary="Activate" />
                                        </ListItem>
                                        <ListItem
                                          button
                                          onClick={() => {
                                            this.handleClose(user.su_ID);
                                            this.deleteUser(refetch, user);
                                          }}
                                        >
                                          <ListItemText primary="Delete" />
                                        </ListItem>
                                      </React.Fragment>
                                    )}
                                  </List>
                                </Popover>
                              </TableRow>
                            );
                          })}
                      </React.Fragment>
                    )}
                    <TableRow>
                      <TablePagination
                        count={
                          this.state.searchData.length < 1 &&
                          this.state.searchTerm !== ""
                            ? this.state.searchData.length
                            : qData.length
                        }
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                          "aria-label": "Next Page"
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableBody>
                </Table>
              </BaseTablePageContent>

              <InviteUsersModal
                open={this.state.inviteDialogOpen}
                onClose={willRefetch =>
                  this.closeInviteDialog(refetch, willRefetch)
                }
                activeCount={{
                  broker: activeCount["broker"] ? activeCount["broker"] : 0,
                  assistant: activeCount["assistant"]
                    ? activeCount["assistant"]
                    : 0
                }}
                userLimits={userLimits}
              />
            </React.Fragment>
          );
        }}
      </Query>
    );
  }
}

UserManagement = compose(
  graphql(ActivateUser, { name: "ActivateUser" }),
  graphql(DeactivateUser, { name: "DeactivateUser" }),
  graphql(DeclineUser, { name: "DeclineUser" }),
  graphql(DeleteUser, { name: "DeleteUser" })
)(UserManagement);

export default UserManagement;



// WEBPACK FOOTER //
// ./src/views/UserManagement/UserManagement.jsx